import { DEFAULT_LOCALE } from '@/constants/index'

export default {
  created () {
    if (!this.$store.getters['bind/requestParams']) {
      this.$store.commit('bind/updateRequestParams', this.$route.query)
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.$store.dispatch('bind/setLang', (this.$route.query.locale || DEFAULT_LOCALE).slice(0, 2))
    })
  },
  methods: {
    redirectWithParams (path, extra = {}) {
      this.$router.push({ path: path, query: { ...this.$store.getters['bind/requestParams'], ...extra } })
    },

    getServerRoleClientParams () {
      let requestParams = this.$store.getters['bind/requestParams'] || {}
      return {
        'app_server_id': requestParams.app_server_id || 0,
        'app_role_id': requestParams.app_role_id || 0,
        'client_type': requestParams.client_type || 0
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/bind/mixins/RequestParamsMixin.js